function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(54.901963%,81.176472%,30.19608%)",
      fillOpacity: 1
    },
    d: "M 5 0 L 19 0 C 21.761719 0 24 2.238281 24 5 L 24 19 C 24 21.761719 21.761719 24 19 24 L 5 24 C 2.238281 24 0 21.761719 0 19 L 0 5 C 0 2.238281 2.238281 0 5 0 Z M 5 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 7 7 L 11 7 L 11 5 L 14 8 L 11 11 L 11 9 L 7 9 C 4.789062 9 3 10.789062 3 13 C 3 15.210938 4.789062 17 7 17 L 9 17 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 17 17 L 13 17 L 13 19 L 10 16 L 13 13 L 13 15 L 17 15 C 19.210938 15 21 13.210938 21 11 C 21 8.789062 19.210938 7 17 7 L 15 7 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 16.5 19.5 L 18 21 L 21 18 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.31f2ea0bfff484d49baa846367ebf795.svg";
export { ForwardRef as ReactComponent };